export enum ReportType {
  SALE_DUMP = 'SALE_DUMP',
  SALE_BY_ATTRIBUTION = 'SALE_BY_ATTRIBUTION',
  SALE_BY_CLIENT = 'SALE_BY_CLIENT',
  MANAGEMENT_USER = 'MANAGEMENT_USER',
  REVIEW_DUMP = 'REVIEW_DUMP',
  USER_DUMP = 'USER_DUMP',
  BOOKING_DUMP = 'BOOKING_DUMP',
  VENUE_DUMP = 'VENUE_DUMP',
  ORGANIZATION_DUMP = 'ORGANIZATION_DUMP',
  MEMBERSHIP_DUMP = 'MEMBERSHIP_DUMP',
  ORGANIZATION_VENUE_DUMP = 'ORGANIZATION_VENUE_DUMP',
  POS_MENU_ITEMS_DUMP = 'POS_MENU_ITEMS_DUMP',
  TLPRO_RESERVATION_DUMP = 'TLPRO_RESERVATION_DUMP',
  TLPRO_RESERVATION_BY_ATTRIBUTION_DUMP = 'TLPRO_RESERVATION_BY_ATTRIBUTION_DUMP',
  TLPRO_RESERVATION_LEADS_DUMP = 'TLPRO_RESERVATION_LEADS_DUMP',
  TLPRO_ADMISSION_DUMP = 'TLPRO_ADMISSION_DUMP',
  TLPRO_ADMISSION_BY_ATTRIBUTION_DUMP = 'TLPRO_ADMISSION_BY_ATTRIBUTION_DUMP',
  TLPRO_ADMISSION_GROUP_DUMP = 'TLPRO_ADMISSION_GROUP_DUMP',
  TLPRO_ADMISSION_GROUP_BY_ATTRIBUTION_DUMP = 'TLPRO_ADMISSION_GROUP_BY_ATTRIBUTION_DUMP',
  TLPRO_ADMISSION_GROUP_BY_INVENTORY_DUMP = 'TLPRO_ADMISSION_GROUP_BY_INVENTORY_DUMP',
  TLPRO_RESERVATION_BY_INVENTORY_DUMP = 'TLPRO_RESERVATION_BY_INVENTORY_DUMP',
  TLPRO_ADMISSION_BY_INVENTORY_DUMP = 'TLPRO_ADMISSION_BY_INVENTORY_DUMP',
  TLPRO_STAFF_DUMP = 'TLPRO_STAFF_DUMP',
  TLPRO_PROMOTER_DUMP = 'TLPRO_PROMOTER_DUMP',
  TLPRO_BOOKEDBY_DUMP = 'TLPRO_BOOKEDBY_DUMP',
  TLPRO_CUSTOMER_DUMP = 'TLPRO_CUSTOMER_DUMP',
  TLPRO_SERVER_DUMP = 'TLPRO_SERVER_DUMP',
  TLPRO_ACTIVITY_LOGS_DUMP = 'TLPRO_ACTIVITY_LOGS_DUMP',
  SALE_TICKETS_DUMP = 'SALE_TICKETS_DUMP',
  SALE_PAYMENTS_DUMP = 'SALE_PAYMENTS_DUMP',
  SALE_TOTALS_DUMP = 'SALE_TOTALS_DUMP',
  SALE_REFUNDED_PAYMENT_DUMP = 'SALE_REFUNDED_PAYMENT_DUMP',
  SALE_TABLES_PREPAID_DUMP = 'SALE_TABLES_PREPAID_DUMP',
  SALE_TABLES_PREPAID_UNPAID_DUMP = 'SALE_TABLES_PREPAID_UNPAID_DUMP',
  SALE_TABLES_RESERVATION_DUMP = 'SALE_TABLES_RESERVATION_DUMP',
  SALE_TABLES_RESERVATION_COMMISSIONS_DUMP = 'SALE_TABLES_RESERVATION_COMMISSIONS_DUMP',
  SALE_TABLES_PREPAID_COMMISSIONS_DUMP = 'SALE_TABLES_PREPAID_COMMISSIONS_DUMP',
  ADMIN_METRICS_DUMP = 'ADMIN_METRICS_DUMP',
  ADMIN_VENUE_METRICS_DUMP = 'ADMIN_VENUE_METRICS_DUMP',
  ADMIN_MARKETING_CONTACTS_DUMP = 'ADMIN_MARKETING_CONTACTS_DUMP',
  TLPRO_VENUE_METRICS_DUMP = 'TLPRO_VENUE_METRICS_DUMP',
}

export enum ReportTypeName {
  SALE_DUMP = 'Sales',
  SALE_BY_ATTRIBUTION = 'Sales By Attribution',
  SALE_BY_CLIENT = 'Sales By Client',
  MANAGEMENT_USER = 'Staff/Promoters',
  REVIEW_DUMP = 'Reviews',
  USER_DUMP = 'Users',
  BOOKING_DUMP = 'Bookings',
  VENUE_DUMP = 'Venues',
  ORGANIZATION_DUMP = 'Organizations',
  MEMBERSHIP_DUMP = 'Memberships',
  ORGANIZATION_VENUE_DUMP = 'Organization Venues',
  POS_MENU_ITEMS_DUMP = 'POS Menu Items',
  //TPRO
  TLPRO_RESERVATION_DUMP = 'Reservations',
  TLPRO_RESERVATION_BY_ATTRIBUTION_DUMP = 'Reservations By Attribution',
  TLPRO_RESERVATION_LEADS_DUMP = 'Reservation Leads',
  TLPRO_ADMISSION_DUMP = 'Admissions',
  TLPRO_ADMISSION_BY_ATTRIBUTION_DUMP = 'Admissions By Attribution',
  TLPRO_ADMISSION_GROUP_DUMP = 'Admissions/Res',
  TLPRO_ADMISSION_GROUP_BY_ATTRIBUTION_DUMP = 'Admissions/Res By Attribution',
  TLPRO_ADMISSION_GROUP_BY_INVENTORY_DUMP = 'Admissions/Res By Inventory',
  TLPRO_RESERVATION_BY_INVENTORY_DUMP = 'Reservations By Inventory',
  TLPRO_ADMISSION_BY_INVENTORY_DUMP = 'Admissions By Inventory',
  TLPRO_STAFF_DUMP = 'Staff',
  TLPRO_PROMOTER_DUMP = 'Promoters',
  TLPRO_BOOKEDBY_DUMP = 'Booked By',
  TLPRO_CUSTOMER_DUMP = 'Customers',
  TLPRO_SERVER_DUMP = 'Servers',
  TLPRO_ACTIVITY_LOGS_DUMP = 'Activity Logs',
  //Sales + Accounting
  SALE_TICKETS_DUMP = 'Sales Tickets',
  SALE_PAYMENTS_DUMP = 'Sales Payments',
  SALE_TOTALS_DUMP = 'Sales Totals',
  SALE_REFUNDED_PAYMENT_DUMP = 'Sales Refunded Payments',
  SALE_TABLES_PREPAID_DUMP = 'Sales Tables Prepaid',
  SALE_TABLES_PREPAID_UNPAID_DUMP = 'Sales Tables Prepaid Unpaid',
  SALE_TABLES_RESERVATION_DUMP = 'Sales Tables Reservation',
  SALE_TABLES_RESERVATION_COMMISSIONS_DUMP = 'Sales Tables Reservation Commissions',
  SALE_TABLES_PREPAID_COMMISSIONS_DUMP = 'Sales Tables Prepaid Commissions',
  ADMIN_METRICS_DUMP = 'Admin Metrics',
  ADMIN_VENUE_METRICS_DUMP = 'Admin Venue Metrics',
  ADMIN_MARKETING_CONTACTS_DUMP = 'Admin Marketing Contacts',
  TLPRO_VENUE_METRICS_DUMP = 'Venue Metrics',
}

export enum ReportState {
  PENDING = 'PENDING',
  GENERATING = 'GENERATING',
  FAILED = 'FAILED',
  COMPLETE = 'COMPLETE',
}

export enum ReportStateName {
  PENDING = 'Pending',
  GENERATING = 'Generating',
  FAILED = 'Failed',
  COMPLETE = 'Complete',
}

export enum ReportEvent {
  CREATED = 'REPORT_CREATED',
  GENERATE_COMPLETED = 'REPORT_GENERATE_COMPLETED',
  GENERATE_FAILED = 'REPORT_GENERATE_FAILED',
}

export enum ReportJob {
  GENERATE = 'REPORT_GENERATE',
}
